import { RefreshIcon } from '@/assets/icons/info-icons/refresh';
import { RefreshButton, Results, TopWrapper } from '@/components/table/filterPage/desktop-filter';
import TablePagination from '@/components/table/tablePagination';
import { ISort, SORT_ORDER } from '@/components/table/types';
import { useResponsive } from '@/hooks/use-responsive';
import { themeVar } from '@/styles/theme';
import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { ENVELOPE_RECIPIENTS_QUERY } from '../queries';
import { EnvelopeRecipientDto, EnvelopeRecipientsResponseDto } from '../types';
import Table from './table/table';

interface DocusignRoutingTabProps {
  sort: ISort;
  paginationValues: { limit: number; offset: number };
  onChangeSort: (value: ISort) => void;
  onChangePaginationData: (limit: number, offset: number) => void;
}

export const DocusignRoutingTab = ({ sort, paginationValues, onChangeSort, onChangePaginationData }: DocusignRoutingTabProps) => {
  const params = useParams();
  const { isMobile, isTablet } = useResponsive();

  const [docusignRoutingTableData, setDocusignRoutingTableData] = useState<EnvelopeRecipientDto[]>([]);
  const [total, setTotal] = useState(0);

  const [isInitialLoad, setIsInitialLoad] = useState(true);

  useEffect(() => {
    if (isInitialLoad) {
      onChangeSort({ key: 'routingOrder', asc: true });
      setIsInitialLoad(false);
    }
  }, [isInitialLoad, sort, onChangeSort]);

  const { loading: envelopeRecipientsLoading, refetch: envelopeRecipientsRefetch } = useQuery<{ envelopeRecipients: EnvelopeRecipientsResponseDto }>(
    ENVELOPE_RECIPIENTS_QUERY,
    {
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true,
      variables: {
        data: {
          allocationId: params?.allocationId,
          sort: sort.key || 'routingOrder',
          order: sort.asc ? SORT_ORDER.ASC : SORT_ORDER.DESC,
          rowsPerPage: Number(paginationValues.limit),
          page: Math.floor(Number(paginationValues.offset) / Number(paginationValues.limit)) + 1
        }
      },
      onCompleted: (data) => {
        setTotal(data?.envelopeRecipients?.total ?? 0);
        setDocusignRoutingTableData(data?.envelopeRecipients?.data ?? []);
      },
      onError: (error) => {
        console.error(error);
      }
    }
  );

  return (
    <>
      <CustomRefetch isMobile={isMobile} isTablet={isTablet}>
        <Results>{total} Results</Results>
        <RefreshButton onClick={() => envelopeRecipientsRefetch()}>
          <RefreshIcon fill={themeVar('action.primary')} />
        </RefreshButton>
      </CustomRefetch>
      <Table
        docusignRoutingTableData={docusignRoutingTableData}
        loading={envelopeRecipientsLoading}
        sort={sort}
        setSort={onChangeSort}
        refetch={() => {}}
      />
      <PaginationWrap>
        <TablePagination savePagination={onChangePaginationData} paginationValues={{ ...paginationValues, total }} refetch={() => null as any} />
      </PaginationWrap>
    </>
  );
};

const CustomRefetch = styled(TopWrapper)<{ isMobile: boolean; isTablet: boolean }>`
  position: sticky;
  top: ${({ isMobile, isTablet }) => (isMobile || isTablet ? '50px' : '0')};
  padding: 50px 0 10px 0;
  background-color: ${themeVar('layer.base')};
  z-index: 10;
`;

const PaginationWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;
